module.exports = __webpack_public_path__ + "static/media/logo-fiscal-box.2c1edaeb.png";